import Typewriter from 'typewriter-effect/dist/core';
import Flickity from "flickity";
require('flickity-fade');

export default () => {
  const heroSlides = document.querySelectorAll(".hero__slide");
  const heroCarousel = document.querySelector('.js-clients-carousel');

  const toggleDropdownMenu = (dropdownBtn, dropdownList) => {
    dropdownBtn.classList.toggle('is-active');
    dropdownList.classList.toggle('is-active');
  };

  const selectItem = (dropdown, item) => {
    dropdown.querySelector('h3').textContent = item.textContent;
  };

  const selectFirstItem = (dropdown, dropdownList) => {
    const firstItem = dropdownList.querySelector('a');
    if (firstItem) {
      selectItem(dropdown, firstItem);
      firstItem.classList.add('selected');
    }
  };

  if (heroSlides) {
    heroSlides.forEach(slide => {
      const dropdownBtn = slide.querySelector(".hero__dropdown__btn");
      const dropdownList = slide.querySelector(".hero__dropdown__content");

      if (dropdownBtn) {
        dropdownBtn.addEventListener('click', () => {
          toggleDropdownMenu(dropdownBtn, dropdownList);
        });
        dropdownList.querySelectorAll('a').forEach(item => {
          item.addEventListener('click', () => {
            selectItem(dropdownBtn, item);
            toggleDropdownMenu(dropdownBtn, dropdownList);
          });
        });
        selectFirstItem(dropdownBtn, dropdownList);

        document.addEventListener('click', (event) => {
          if (!dropdownBtn.contains(event.target) && !dropdownList.contains(event.target)) {
            dropdownBtn.classList.remove('is-active');
            dropdownList.classList.remove('is-active');
          }
        });
      }
    });
  }



  if (heroCarousel) {
    const flickityInstance = new Flickity(heroCarousel, {
      cellAlign: 'left',
      prevNextButtons: false,
      draggable: false,
      autoPlay: false,
      fade: true,
      pageDots: false,
    });

    const json = JSON.parse(heroCarousel.getAttribute('data-options'));
    const anchor = document.getElementById('typewriter');
    const typeWriter = new Typewriter(anchor, {
      loop: true,
      pauseFor: 5000
    });

    for (const text of json) {
      typeWriter
        .callFunction(() => {
          flickityInstance.select(text.index);
        })
        .typeString(text.title)
        .pauseFor(5000)
        .deleteAll()
    }

    typeWriter.start();
  }
};
